"use client";

import React from "react";
import { Activity, Users, Bot, CalendarHeart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const stats = [{
  label: "Network Uptime",
  value: "99.9%",
  icon: Activity
}, {
  label: "Active Renters",
  value: "1500+",
  icon: Users
}, {
  label: "Smart Hubs",
  value: "100+",
  icon: Bot
}, {
  label: "Powerbanks",
  value: "3000+",
  icon: CalendarHeart
}];
export default function Statistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="17745" id="statistics" ref={ref} className="bg-background text-foreground w-full py-16 border-y border-border/40">
      <div className={cn("container mx-auto px-4 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, i) => <div key={i} data-index={i} className={cn("flex flex-col items-center justify-center text-center p-6", "lg:border-r lg:border-border/60 lg:last:border-r-0", "md:max-lg:nth-[odd]:border-r md:max-lg:border-border/60", "max-md:border-b max-md:border-border/60 max-md:last:border-b-0")}>
              <div className="mb-4 p-4 rounded-2xl bg-primary/5 shadow-sm border border-primary/10 transition-transform duration-700 hover:scale-110">
                <stat.icon className="w-8 h-8 text-primary stroke-[1.5] animate-pulse" />
              </div>
              <span className="text-4xl md:text-5xl font-extrabold text-primary mb-2 tracking-tighter font-mono">
                {stat.value}
              </span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-bold font-sans">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}